import type { GeoLocation } from './geolocation'

export type When = 'any' | 'weekend' | '30days'
export type Sort = 'soonest' | 'nearest' | 'mostEntries'

/** All filter/search/sort state App.tsx owns, passed down to SearchBar/FilterPanel/FilterChips
 *  and up to eventsListApi's EventsListQuery. One shape for every consumer avoids three
 *  slightly-different prop shapes drifting apart. */
export interface FilterState {
  search: string
  location: GeoLocation | null
  radiusMi: number
  when: When
  regState: string[]
  raceType: string[]
  /** Real vehicletypecodes.typeName values (e.g. "1/10th Electric Truck") - see
   *  FilterOptions.vehicleType. */
  vehicleType: string[]
  seriesTrackId: number | null
  sort: Sort
}

export const DEFAULT_FILTERS: FilterState = {
  search: '',
  location: null,
  radiusMi: 250,
  when: 'any',
  regState: [],
  raceType: [],
  vehicleType: [],
  seriesTrackId: null,
  sort: 'soonest',
}

export function activeFilterCount(f: FilterState): number {
  return (
    f.regState.length + f.raceType.length + f.vehicleType.length + (f.seriesTrackId != null ? 1 : 0) + (f.when !== 'any' ? 1 : 0)
  )
}

export function toggleInList(list: string[], value: string): string[] {
  return list.includes(value) ? list.filter((v) => v !== value) : [...list, value]
}
